// auto generated by scripts/build.js
export default '2.9.1';
